import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Workflow, WorkflowStatus, WorkflowType, PageResponse } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {
  private readonly apiUrl = `${environment.apiUrl}/workflows`;

  constructor(private http: HttpClient) {}

  getWorkflows(search = '', page = 0, size = 10, status: WorkflowStatus | 'ALL' = 'ALL', sort = 'name,asc', type: WorkflowType | 'ALL' = 'ALL'): Observable<PageResponse<Workflow>> {
    const params = new HttpParams()
      .set('search', search)
      .set('page', String(page))
      .set('size', String(size))
      .set('status', status)
      .set('sort', sort)
      .set('type', type);

    return this.http.get<PageResponse<Workflow>>(this.apiUrl, { params });
  }

  getActiveWorkflows(type: WorkflowType | 'ALL' = WorkflowType.PROJECT): Observable<Workflow[]> {
    const params = new HttpParams().set('type', type);
    return this.http.get<Workflow[]>(`${this.apiUrl}/active`, { params });
  }

  getWorkflowById(id: number): Observable<Workflow> {
    return this.http.get<Workflow>(`${this.apiUrl}/${id}`);
  }

  createWorkflow(workflow: Workflow): Observable<Workflow> {
    return this.http.post<Workflow>(this.apiUrl, workflow);
  }

  updateWorkflow(id: number, workflow: Workflow): Observable<Workflow> {
    return this.http.put<Workflow>(`${this.apiUrl}/${id}`, workflow);
  }

  deleteWorkflow(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  canDeleteWorkflow(id: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/${id}/can-delete`);
  }

  createWorkflowVersion(id: number): Observable<Workflow> {
    return this.http.post<Workflow>(`${this.apiUrl}/${id}/version`, null);
  }
}
